import { EventHandler } from "../../../util/event/EventHandler";
import { AbstractControl } from "../../control/AbstractControl";
/**
 * AbstractStakeSelector.ts
 */
export class AbstractStakeSelector extends AbstractControl {
    create() {
        super.create();
        this.isEnabled = true;
    }
    update(stakeSelectorData) {
        this.stakeSelectorData = stakeSelectorData;
    }
    enable() {
        this.isEnabled = true;
    }
    disable() {
        this.isEnabled = false;
    }
    dispatchChange() {
        this.callHandler(this.changeHandler);
    }
    getData() {
        return this.stakeSelectorData;
    }
    getOriginalPosition() {
        return this.uiProperties.position;
    }
    refresh(dispatch) {
    }
    close() {
    }
    onChange(handler, scope) {
        this.changeHandler = new EventHandler(handler, scope);
    }
    onOpen(handler, scope) {
        this.openHandler = new EventHandler(handler, scope);
    }
    onClose(handler, scope) {
        this.closeHandler = new EventHandler(handler, scope);
    }
}
//# sourceMappingURL=AbstractStakeSelector.js.map